<div class="row justify-content-center">
    <div class="col-auto">
        <div class="section-header mb-4 d-flex text-center justify-content-center gap-2" style="max-width: 520px;">
            <span class="material-symbols-outlined">work</span>
            <h1 class="h4">Gestión de <strong class="fw-semibold text-colonial">Ocupaciones</strong></h1>
        </div>
        <p class="text-muted mx-auto text-center" style="max-width: 520px;">
            Gestiona las categorías de las ocupaciones.
        </p>
    </div>
</div>

<div class="row justify-content-center">
    <div class="col-12 col-xl-10">
        <div class="card shadow-sm border-0 overflow-hidden rounded-4">
            <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">list</span>
                    <span>Ocupaciones</span>
                </h3>
                <div class="d-flex align-items-center gap-3">
                    <div class="d-flex align-items-center gap-2">
                        <label for="categoryFilter" class="mb-0 text-muted small">Categoría:</label>
                        <select id="categoryFilter" class="form-select form-select-sm" style="min-width: 150px;"
                            [(ngModel)]="selectedCategory" (ngModelChange)="onFilterChange()">
                            <option *ngFor="let opt of categoryOptions" [ngValue]="opt.value">{{ opt.label }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <shared-table-container>
                <shared-table [headers]="tableHeaders" [items]="filteredOccupations"
                    searchPlaceholder="Buscar ocupación" title="Ocupaciones" (itemClicked)="openModal($event)"
                    (searching)="onSearchChange($event)">
                    <ng-template let-category="category" sharedTableColumn="category">
                        <span class="badge text-white" [ngClass]="{
                            'bg-colonial': category,
                            'bg-secondary': !category
                        }">
                            {{ category ? 'Categoría ' + category : 'Sin categoría' }}
                        </span>
                    </ng-template>
                </shared-table>
            </shared-table-container>
        </div>
    </div>
</div>